// The unbranded arm of every donor brand colour (CON-115).
//
// When a nonprofit has no brand colour, a donor surface paints NEUTRAL — never
// a stand-in hue (D4: no brand hue is ever a static value on the donor side).
// The CSS ramp reads already fall back to neutral tokens in the stylesheet;
// this is the same mapping for the JS readers that cannot take a `var()`:
// contrast math (`setContrast`, `brandTextFor`), Stripe's appearance object,
// and inline styles that feed either.
//
// Every value is READ from the donor tier-2 set (`values.js`, the ESM mirror
// of donor.css), never written here, so a token change moves it and
// `tokens:parity` catches drift. The step → token mapping mirrors checkout's
// tailwind-theme.css unbranded arms, so JS and CSS agree on what an
// unbranded surface looks like:
//
//   accent-60 · pressed / hover · brand text → text-primary
//   accent-50 · the primary action's fill    → text-secondary
//   accent-40 · mid accents                  → text-tertiary
//   accent-20 · hover wash, dividers         → surface-sunken
//   accent-10 · selected / secondary fill    → surface-2
//   accent-5  · faintest wash                → surface-1
// `donorColor` (the donor colour group alone), not the whole `donor` value set:
// every widget reaches this through `useBrandColors`, so it must stay small
// (CON-331).
import { donorColor } from '@charitystack/design-tokens';

const palette = Object.freeze({
  'accent-60': donorColor.textPrimary,
  'accent-50': donorColor.textPrimary,
  'accent-40': donorColor.textTertiary,
  'accent-20': donorColor.surfaceSunken,
  'accent-10': donorColor.surface2,
  'accent-5': donorColor.surface1,
});

/**
 * The neutral theme, in the legacy shape the donor components already take:
 * `lightColor` / `primaryColor` are the action fill, `darkColor` /
 * `buttonPressColor` its hover and pressed state, `brandColors` the palette.
 */
export const UNBRANDED_THEME = Object.freeze({
  primaryColor: palette['accent-50'],
  lightColor: palette['accent-50'],
  darkColor: palette['accent-60'],
  buttonPressColor: palette['accent-60'],
  brandColors: palette,
});
